import { TooltipHost } from "@fluentui/react";
import React from "react";
import CustomToolTipHost from "../../../../components/CustomToolTipHost/CustomToolTipHost";
import { isMobile } from "react-device-detect";

const RowBadge = (props) => {
  const badgeStyle = {
    marginLeft: props.isQueueBadge != undefined && props.isQueueBadge ? "0px" : "10px",
    backgroundColor: props.colorObj != undefined?props.colorObj.background:"#BBDEFF",
    marginTop: props.isQueueBadge != undefined && props.isQueueBadge ? "5px" : "0px",
    height: "18px",
    color:  props.colorObj != undefined?props.colorObj.color:"#0035BE",
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    padding: "0px 5px",
    borderRadius: "10px",
    lineHeight: "16px",
    gap: "10px",
    cursor: "default"
  };

  const mobileBadgeStyle = {
    backgroundColor: props.colorObj != undefined?props.colorObj.background:"#BBDEFF",
    height: "18px",
    fontSize: "10px",
    color:  props.colorObj != undefined?props.colorObj.color:"#0035BE",
    display: "flex",
    alignItems: "center",
    width: "fit-content",
    fontFamily: "Open Sans",
    fontWeight: "700",
    padding: "0px 5px",
    borderRadius: "10px",
    lineHeight: "16px",
    gap: "10px",
  }

  return (
    <>
      <div style={props.style != undefined? props.style:isMobile?mobileBadgeStyle:badgeStyle}>
        <CustomToolTipHost content={props.tooltipText != undefined? props.tooltipText: props.name} id={"tooltip_" + props.name} toolTipProps={props.toolTipProps} closeDelay={props.closeDelay}>
          <span className={`study-list-row-badge ${props.customClassName}`} 
          style={{width:props.width!=undefined?props.width:"unset"}}
          >
            {props.name}</span>
        </CustomToolTipHost>
      </div>
    </>
  );
};

export default RowBadge;
